class WidgetUrlParameterStore {
  private static instance: WidgetUrlParameterStore;
  private urlParams?: URLSearchParams;
  private isInitialized = false;

  private constructor() {}

  public static getInstance(): WidgetUrlParameterStore {
    if (!WidgetUrlParameterStore.instance) {
      WidgetUrlParameterStore.instance = new WidgetUrlParameterStore();
    }
    return WidgetUrlParameterStore.instance;
  }

  public initialize(searchString?: string) {
    if (!this.isInitialized) {
      this.urlParams = new URLSearchParams(
        searchString || window.location.search,
      );
      this.isInitialized = true;
    }
  }

  public reset() {
    this.urlParams = undefined;
    this.isInitialized = false;
  }

  public getUrlParams(): URLSearchParams {
    if (!this.isInitialized) {
      throw new Error('ParameterStore must be initialized before use');
    }
    return this.urlParams!;
  }

  public isReady(): boolean {
    return this.isInitialized;
  }
}

export default WidgetUrlParameterStore;
